import React from "react";
import { useI18n } from "../i18n";

export default function LegalPage({ ns }) {
  const { t } = useI18n();
  const sections = t(`${ns}.sections`) || [];

  return (
    <article className="legal-page">
      <div className="legal-hero">
        <div className="container">
          <span className="eyebrow eyebrow-light">{t("brand.name")}</span>
          <h1 className="legal-title">{t(`${ns}.title`)}</h1>
          <p className="legal-updated">
            {t("common.lastUpdated")}: {t("common.updatedDate")}
          </p>
        </div>
      </div>
      <div className="container legal-body">
        <p className="legal-intro">{t(`${ns}.intro`)}</p>
        {sections.map((section) => (
          <section className="legal-section" key={section.h}>
            <h2 className="legal-h2">{section.h}</h2>
            {(section.p || []).map((paragraph) => (
              <p className="legal-p" key={paragraph.slice(0, 40)}>
                {paragraph}
              </p>
            ))}
            {section.li && (
              <ul className="legal-ul">
                {section.li.map((item) => (
                  <li key={item.slice(0, 40)}>{item}</li>
                ))}
              </ul>
            )}
          </section>
        ))}
      </div>
    </article>
  );
}
